import { useContext, useEffect, useState } from 'react';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

import { RxFormContext } from '../Context';
import { expand } from '../utils/expand';
import { flatObjectCompare } from '../utils/flatObjectCompare';
import { createDebug } from '../utils/debug';

const debug = createDebug('useFormState');

export function useFormState() {
    const { initialValues, getValueStream, getSubmitCountStream, getErrorStream } = useContext(RxFormContext);
    const [state, setState] = useState({ values: initialValues, errors: {}, submits: 0 });

    useEffect(() => {
        debug('++mount');
        const values = getValueStream().pipe(distinctUntilChanged(flatObjectCompare), map(expand));
        const errors = getErrorStream().pipe(distinctUntilChanged(flatObjectCompare));
        const submits = getSubmitCountStream().pipe(distinctUntilChanged());
        const vals = combineLatest([values, errors, submits]).pipe(
            tap(([values, errors, submits]) => {
                debug(`setState(...)`, { values, errors, submits });
                setState({ values, errors, submits });
            }),
        );
        const sub = vals.subscribe();
        return () => {
            debug('--unmount');
            sub.unsubscribe();
        };
    }, [getErrorStream, getSubmitCountStream, getValueStream]);
    return state;
}
